"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const EditorSection = ({
  className,
  elevation = 1,
  expanded = false,
  children
}) => {
  const classes = useStyles();

  if (!elevation) {
    return _react.default.createElement("section", {
      className: className || classes.root,
      "aria-expanded": expanded
    }, children);
  }

  return _react.default.createElement(_Paper.default, {
    elevation: elevation,
    square: true,
    className: className || classes.root,
    "aria-expanded": expanded
  }, children);
};

var _default = EditorSection;
exports.default = _default;
module.exports = exports.default;